module.exports = __webpack_public_path__ + "h5/img/summer-title4-1.9c8e8455.png";